import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useInfFiles } from '../inf-files';
import { useColumns } from './inf-file-closed-columns';
import { Toolbar } from './inf-files-closed-toolbar';

export const INF_FILES_CLOSED_IDENTIFIER = 'INF_FILES_CLOSED';
export const INF_FILES_CLOSED_VERSION = 9;

export function InfFilesClosed() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useInfFiles({
    evidenceProps: {
      identifier: INF_FILES_CLOSED_IDENTIFIER,
      version: INF_FILES_CLOSED_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.CLOSED,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__INF_FILES_CLOSED__TABLE__TITLE',
          defaultMessage: 'Spisy INF - Uzavřené',
        }),
        toolbarProps: {
          after: <Toolbar />,
        },
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
          disableBtn: (btn) => !['REFRESH', 'SHARE'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
